import { useTranslation } from 'react-i18next';
import { Button } from '@shared/components/ui/button';

interface ActiveCartItemProps {
  cartCode: string;
  onChange: () => void;
}

/**
 * Item de carrito activo - Muestra el carrito validado
 *
 * Reemplaza al scanner cuando se ha validado exitosamente un carrito
 */
export const ActiveCartItem = ({ cartCode, onChange }: ActiveCartItemProps) => {
  const { t } = useTranslation('extraWorkOrdersModule');

  return (
    <div className="bg-green-50 dark:bg-green-950/20 border border-border rounded-lg p-4">
      <div className="flex items-center justify-between gap-4">
        {/* Información del carrito */}
        <div className="flex items-center gap-3 flex-1 min-w-0">
          {/* Icono de carrito */}
          <div className="bg-green-100 dark:bg-green-900/40 rounded-lg p-2 flex-shrink-0">
            <svg
              className="w-5 h-5 text-green-600 dark:text-green-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>

          {/* Texto del carrito */}
          <div className="flex-1 min-w-0">
            <p className="text-xs text-success font-medium mb-0.5">
              {t('detail.scanner.active_cart', 'Carrito Activo')}
            </p>
            <p className="text-base font-bold text-title truncate">{cartCode}</p>
          </div>
        </div>

        {/* Botón Cambiar */}
        <Button
          variant="ghost"
          size="sm"
          onClick={onChange}
          className="text-sm font-medium text-green-700 dark:text-green-300 hover:bg-green-100 dark:hover:bg-green-900/40 rounded-md transition-colors"
          data-testid="change-cart-button"
        >
          {t('detail.scanner.change', 'Cambiar')}
        </Button>
      </div>
    </div>
  );
};
